import PropTypes from 'prop-types';

/**
 * Business idea definition
 */
export const BusinessIdea = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  // category: PropTypes.string,
  report: PropTypes.oneOfType([
    // Future backend structure with sections array
    PropTypes.shape({
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          content: PropTypes.string.isRequired
        })
      )
    }),
    // Current flat structure (flexible - can have any report fields)
    PropTypes.object
  ]),
  businessPlan: PropTypes.object
});

/**
 * User profile from ChoiceFlow answers
 */
export const UserProfile = PropTypes.shape({
  preferences: PropTypes.object,
  answers: PropTypes.object.isRequired
});

/**
 * Business results data structure
 * Supports either 'ideas' or 'items' array (one is required)
 * @param props
 * @param propName
 * @param componentName
 */
export const BusinessIdeaResultsData = (props, propName, componentName) => {
  const data = props[propName];

  if (!data) {
    return new Error(`The prop '${propName}' is required in '${componentName}'.`);
  }

  const hasIdeas = Array.isArray(data.ideas) && data.ideas.length > 0;
  const hasItems = Array.isArray(data.items) && data.items.length > 0;

  if (!hasIdeas && !hasItems) {
    return new Error(
      `The prop '${propName}' in '${componentName}' must have either 'ideas' or 'items' array with at least one element.`
    );
  }

  return null;
};

/**
 * Main BusinessResults props
 */
export const BusinessIdeaResultsProps = PropTypes.shape({
  data: BusinessIdeaResultsData,
  onEmailReport: PropTypes.func,
  onGenerateMore: PropTypes.func,
  onIdeaSelect: PropTypes.func
});
